'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  domain: '',
  menuToggle: {
    label: 'MENU'
  },
  logo: {
    href: '/'
  },
  mainBtn: [{
    text: 'CONTACTO',
    link: '/contacto'
  }, {
    text: 'LOGIN',
    link: ''
  }],
  loginLink: {
    text: 'LOGIN',
    src: ''
  },
  siteLinks: [{
    title: {
      text: 'PRODUCTOS'
    },
    list: [{
      text: 'Gastos',
      src: '',
      classes: 'sub-menu',
      subMenu: [{
        text: 'Gestión de recibos con ExpenseIt',
        src: '/receipt-management-app'
      }, {
        text: 'Budget',
        src: '/budget-management'
      }, {
        text: 'Servicio de Auditoría',
        src: '/travel-expense-audit-service '
      }, {
        text: 'Concur Request',
        src: '/concur-request-travel-solutions'
      }]
    }, {
      text: 'Viajes',
      src: '/reserva-de-viajes'
    }, {
      text: 'Productos inteligentes',
      src: '',
      classes: 'sub-menu',
      subMenu: [{
        text: 'Consultative Intelligence',
        src: '/travel-expense-data-analysis'
      }, {
        text: 'Inteligencia',
        src: '/business-intelligence'
      }, {
        text: 'Soporte administrador',
        src: '/service-administration'
      }, {
        text: 'Preferred Care',
        src: '/preferred-care'
      }]
    }, {
      text: 'Expense Demo',
      src: '/self-guided-demo-expense',
      classes: 'call-out'
    }]
  }, {
    title: {
      text: 'SOBRE CONCUR'
    },
    list: [{
      text: 'Integracion de SAP',
      src: '/integracion-de-sap'
    }, {
      text: 'Por qué Concur',
      src: '/porque-concur'
    }]
  }, {
    title: {
      text: 'RECURSOS'
    },
    list: [{
      text: 'Declaracion de privacidad',
      src: '/declaracion-de-privacidad'
    }]
  }],
  supportLinks: [{
    text: 'CONTACTO',
    href: '/contacto'
  }],
  mobileAppText: {
    text: 'GET CONCUR MOBILE APP'
  }
};